import React, { useEffect, useCallback, useState} from 'react';
import SingleLFOComponent from "components/lfo/SingleLFOComponent.js"
import MainFMParameters from "components/instruments/MainFMParameters.js";
import Figures from "components/effects/jaki/Figures.js";
import GraphicalEnvelope from "components/instruments/envelope/GraphicalEnvelope.js";
import Colors from 'components/Colors.js';
import OperatorsMixer from "components/instruments/fm/OperatorsMixer.js";
import {JAKI_FIGURES, JAKI_PARAMS, LFO, FM_PARAMETERS, PLANAR_SNAPSHOTS, OPERATORS_MIXER} from 'constants/pullable-types.js';
import DrumRouter from "components/effects/jaki/DrumRouter.js";
import PlaneSnapshots from "components/effects/plane/PlaneSnapshots.js";
import {connect} from 'react-redux';

const colors = new Colors();

const PullableInstrument = ({
    onDeleteEffect,
    sequencerEngine,
    instrumentPart
}) => { 
    let [oscillatorDetails, setOscillatorDetails] = useState(undefined);
    let [showWaveform, setShowWaveform] = useState(undefined);
    let {effect, instrument, track, type, subType} = instrumentPart;
    let inner = '';

    let header = (
        <div className="pulled-header">
          {instrument && type === LFO &&
           <div className="lfo-name">LFO {instrument.number}</div>}
          {instrument && type === "MODULE_ENVELOPE" &&
           <div className="lfo-name">Envelope {instrument.number}</div>}
          {track &&
           <div style={{backgroundColor: colors.getColorForTrack(track)}} className="effect-from">
             {track.envelopesTrack ?
              track.name :
              (track.trackNumber + 1) + '. ' + track.getName()}
           </div>}
          <div onClick={onDeleteEffect} className="delete-button">
            -
          </div>
        </div>
    );
    
    let color = colors.getColorForTrack(track);
    if (type === OPERATORS_MIXER) {
        inner = (
            <OperatorsMixer
             isDraggable={false}
              setOscillatorDetails={setOscillatorDetails}
              oscillatorDetails={oscillatorDetails}
              showWaveform={showWaveform}
              setShowWaveform={setShowWaveform}
              color={color}
              sequencerEngine={sequencerEngine}
              instrument={instrument}/>
        );
    } else if (type === "SYNTH_ENVELOPE") {
        let envelope;
        let hasRelease = true;
        if (subType === "Amp") {
            envelope = instrument.ampEnvelope;
        } else if (subType === 'A') {
            envelope = instrument.oscillatorNodes[1].ampEnvelope;
        } else if (subType === 'B1') {
            envelope = instrument.oscillatorNodes[2].ampEnvelope;
        } else if (subType === 'B2') {
            envelope = instrument.oscillatorNodes[3].ampEnvelope;
        }
        console.log('subtype = ', subType);
        inner  = (
            <GraphicalEnvelope
              instrument={instrument}
              width={200}
              fillColor={color}
              lineColor={color}
              sequencerEngine={sequencerEngine}
              envelope={envelope}
              name={subType}
              hasRelease={hasRelease}
              hasLevel={false}
            />);
    } else if (type === "MODULE_ENVELOPE") {
        inner = (
            <GraphicalEnvelope
              name={"Env " + subType}
              envelope={instrument}
              width={200}
              hasRelease={true}
              hasLevel={false}
              sequencerEngine={sequencerEngine}/>
        );
    } else if (type === PLANAR_SNAPSHOTS) {
        inner = (
            <PlaneSnapshots effect={effect}/>
        );
    } else if (type === JAKI_PARAMS) {
        inner = (
            <DrumRouter isDraggable={false} effect={effect}/>
        );
    } else if (type === JAKI_FIGURES) {
        inner = (
            <Figures isDraggable={false} effect={effect}/>
        );
    } else if (type === FM_PARAMETERS) {
        inner = (
            <MainFMParameters
              isDraggable={false}
              color={color}
              sequencerEngine={sequencerEngine}
              instrument={instrument}/>
        );
    } else if (type === LFO) {
        inner = (
            <SingleLFOComponent
              isDraggable={false}
              hideName={true}
              lfo={instrument}
              sequencerEngine={sequencerEngine}
            />
        );
    }

    return (
        <div className="pulled-instrument">
          {header}
          {inner}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PullableInstrument);
